export const environment = {
  production: true,
  apiBaseUrl: '#{ApiBaseUrl}#',
  sentryDsn: '#{SentryDsn}#',
  sentryEnvironment: '#{SentryEnvironment}#',
};
